export default function thumbItemInit() {
  const targetClassName = ".js__thumb-item";
  const thumbWrapperSelector = ".js__thumb-wrapper";
  const height = 170; // thumb位置調整用

  class ThumbClass {
    static instanceList = [];

    static init = () => {
      ThumbClass.createThumbWrapper();
      ThumbClass.instanceList = [...document.querySelectorAll(targetClassName)].map((v) => {
        return new ThumbClass(v);
      });
    }

    static createThumbWrapper = () => {
      const thumbWrapper = document.createElement("div");
      thumbWrapper.classList.add("js__thumb-wrapper");
      document.querySelector(".js__container").appendChild(thumbWrapper);

      // 画像を生成してthumbWrapperに追加
      const thumbImg = document.createElement("img");
      thumbWrapper.appendChild(thumbImg);
    }

    static isMobile = () => {
      return window.innerWidth <= 767; // 例として幅が767ピクセル以下をスマートフォンと見なす
    }

    constructor(ele) {
      this.instanceType = "ThumbClass";
      this.ele = ele;
      this.thumbUrl = this.ele.getAttribute("data-thumb") || "";
      this.thumbWrapper = document.querySelector(thumbWrapperSelector);
      this.imgElement = this.thumbWrapper.querySelector("img");
      this.note = this.ele.getAttribute("data-thumb-note") || false;
      this.noteColor = this.ele.getAttribute("data-thumb-note-color") || "";

      if (this.thumbUrl !== "") {
        this.ele.addEventListener("mouseenter", () => {
          this.showImage();
        });

        this.ele.addEventListener("mouseleave", () => {
          this.hideImage();
        });
      }
    }
    
    showImage() {
      const rect = this.ele.getBoundingClientRect();
      this.imgElement.src = this.thumbUrl;

      // ヘッダーの高さを取得
      const headerHeight = document.querySelector(".l-header").offsetHeight;

      // this.ele の幅を取得
      const eleWidth = rect.width;

      // this.ele の高さを取得
      const eleHeight = rect.height;

      // thumbWrapper の中央が this.ele の中央に揃うように計算
      this.thumbWrapper.style.top = `${rect.top + window.scrollY - headerHeight - height / 2 - eleHeight / 2}px`; // ヘッダーの高さを考慮
      if (ThumbClass.isMobile()) {
        this.thumbWrapper.style.left = `auto`;
        this.thumbWrapper.style.right = `0`;
        this.thumbWrapper.style.width = `50%`;
      } else {
        this.thumbWrapper.style.left = `${rect.right}px`;
        this.thumbWrapper.style.right = `auto`;
        this.thumbWrapper.style.width = `260px`;
      }
      this.thumbWrapper.style.display = "block";

      // 既存の noteText 要素があるか確認
      let noteText = this.thumbWrapper.querySelector(".thumb-note");

      if (!noteText) {
        // 既存の noteText 要素がない場合は新しい要素を作成
        noteText = document.createElement("div");
        noteText.classList.add("thumb-note");
        this.thumbWrapper.appendChild(noteText);
      }

      if (this.note === "1") {
        // テキストとスタイルを設定
        noteText.style.display = "block";
        noteText.innerHTML = '<div class="hide_if_ch hide_if_cn hide_if_en">※イメージ写真</div><div class="hide_if_ja hide_if_ch hide_if_cn">* For illustrative purpose</div><div class="hide_if_ja hide_if_en">※图片照片</div>'; // または this.note に置き換え
        noteText.style.position = "absolute";
        noteText.style.left = "1rem";
        noteText.style.bottom = "1rem";
        if (this.noteColor) {
          noteText.style.color = this.noteColor;
        }
      } else {
        // this.note が "1" でない場合は noteText を非表示にする
        noteText.style.display = "none";
      }
    }

    hideImage() {
      this.thumbWrapper.style.display = "none";
    }
  }

  ThumbClass.init();
}
